export default function FernL() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 491 
      360"
    >
      <path
        fill="#008737"
        d="M70.857 283.636 0 0c365.184-.001 490.546 354.545 490.546 354.545l-92.659-92.727-5.45 98.182-38.154-152.727L332.481 360l-27.253-196.364-32.703 180-38.98-204.195-20.975 182.377-62.904-224.337L141.713 300 95.161 81.117 70.856 283.636Z"
      />
    </svg>
  );
}
